export default __webpack_public_path__ + "fonts/SF-Pro-Display-Semibold.woff2";